const getPaymentURL = (rootState) => rootState.paymentURL;

export default getPaymentURL;
